export enum FeatureToggle {
  SANOFI_DUPIXENT = "sanofi-dupixent",
  HPP_STRENSIQ = "hpp-strensiq",
  ZEPBOUND_OSA = "zepbound-osa",
  WEGOVY_MASH = "wegovy-mash",
  ASTHMA = "asthma",
  LIVER_TRANSPLANT = "liver-transplant",

  APPEAL_HUB_REFERRAL_FLOW_V2 = "appeal-hub-referral-flow-v2",
  APPEAL_HUB_SEARCH_AND_FILTER_V2 = "appeal-hub-search-and-filter-v2",

  KLAVIYO_PATIENT_REFERRAL_EMAILS = "klaviyo-patient-referral-emails",
  KLAVIYO_PAYMENT_SUCCESS_EMAILS = "klaviyo-payment-success-emails",
  DISABLE_LETTER_ISSUE_EMAILS = "disable-letter-issue-emails",

  NOTICE_OF_BENEFIT_CHANGE_SUPPORTING_DOCUMENT_ENABLED = "notice-of-benefit-change-supporting-document-enabled",

  CLINICAL_EVIDENCE_REVIEW = "clinical-evidence-review",
  FEP_DUPIXENT_2026_OPTIONS = "fep-dupixent-2026-options",
}
